module.exports = __webpack_public_path__ + "static/media/sliders-solid.8b36a021.svg";